import { UserSubscritpion } from './../model/newUser';
import { Component, OnInit, ViewChild, Renderer, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NewUser } from '../model/newUser';
import { Router } from '@angular/router';
import { CookieNames, ApiEndpoints } from '../constant';
import { HttpClientService, ErrorManagerService, CookieManagerService, CustomObserverService, emailValidator, matchingPasswords, mobileValidator, GoogleService, SwalService } from '../../shared';
import { TranslateService } from '@ngx-translate/core';
import { ImageCropperComponent, CropperSettings } from 'ng2-img-cropper';
import { LocalStorageService } from 'angular-2-local-storage';
import swal from 'sweetalert2';
import { SubscriptionInfoService } from '../subscription-packages/subscription-info-service.service';
declare let ga: Function;
declare var $: any;


@Component({
  selector: 'app-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.css', '../../css/paper-sets.component.css', '../../css/login-selection.component.css'],
  providers: [FormBuilder, GoogleService],
})
export class SettingComponent implements OnInit {

  public isFinilize: boolean = true;
  settingsChangePassword: FormGroup;
  settingsChangePasswordSocal: FormGroup;
  settingsProfile: FormGroup;
  settingsPayment: FormGroup;
  imageProfile: any;
  public showImageCropper: boolean = true;
  public shown: string = 'FIRST';
  public apiRequstWaiter : boolean = true;
  isSoundEnambled: boolean;
  emailEdit: boolean = false;
  mobileEdit: boolean = false;
  editEmailId: number;
  editMobileId: number;
  isSaveButtonClick: boolean = false;

  change: EventEmitter<boolean> = new EventEmitter<boolean>();

  public user: NewUser = new NewUser({});
  public selectedUser: NewUser = new NewUser({});
  public data: any;
  public cropperSettings: CropperSettings;
  public settingComponent: SettingComponent;

  public currentSubscriptionPackageId :string;
  public currentSubscriptionPackage:UserSubscritpion;


  @ViewChild('cropper', undefined) cropper: ImageCropperComponent;
  constructor(private httpClientService: HttpClientService,
    private customObserverService: CustomObserverService,
    private localStorageService: LocalStorageService,
    private cookieManagerService: CookieManagerService,
    private translateService: TranslateService,
    private errorManagerService: ErrorManagerService,
    private subscriptionInfoService : SubscriptionInfoService,
    private router: Router,
    public fb: FormBuilder,
    public fb1: FormBuilder,
    public fb2: FormBuilder,
    public fb3: FormBuilder,
    private render: Renderer,
    public googleService: GoogleService, private swalService: SwalService) {
    this.cropperSettings = new CropperSettings();
    this.cropperSettings.width = 200;
    this.cropperSettings.height = 200;
    this.cropperSettings.croppedWidth = 200;
    this.cropperSettings.croppedHeight = 200;
    this.cropperSettings.canvasWidth = 400;
    this.cropperSettings.canvasHeight = 300;
    this.cropperSettings.minWidth = 100;
    this.cropperSettings.minHeight = 100;
    this.cropperSettings.rounded = false;
    // this.cropperSettings.responsive
    this.cropperSettings.cropperDrawSettings.strokeColor = 'rgba(255,255,255,0.8)';
    this.cropperSettings.cropperDrawSettings.strokeWidth = 2;
    this.cropperSettings.noFileInput = true;
    this.data = {};

    this.settingsChangePassword = fb.group({
      'password': ['', Validators.compose([Validators.required, Validators.minLength(6)])],
      'newPassword': ['', Validators.compose([Validators.required, Validators.minLength(6)])],
      'reEnterPassword': ['', Validators.compose([Validators.required, Validators.minLength(6)])],
    }, { validator: matchingPasswords('newPassword', 'reEnterPassword') });
    this.settingsChangePasswordSocal = fb3.group({
      'newPassword': ['', Validators.compose([Validators.required, Validators.minLength(6)])],
      'reEnterPassword': ['', Validators.compose([Validators.required, Validators.minLength(6)])],
    }, { validator: matchingPasswords('newPassword', 'reEnterPassword') });
    this.settingsProfile = fb1.group({
      'firstname': ['', Validators.compose([Validators.required])],
      'lastname': ['', Validators.compose([Validators.required])],
      'email': [{ value: '', disabled: false }, Validators.compose([emailValidator])],
    });
    this.settingsPayment = fb2.group({
      'mobileNumber': [{ value: '', disabled: false }, Validators.compose([mobileValidator])],
      'billemail': [{ value: '', disabled: false }, Validators.compose([emailValidator])],
    });
    this.customObserverService.tab$.subscribe(value => {
      this.shown = value;
    });
  }

  fileChangeListener($event) {
    if(!$event.target.files[0]){
      return;
    }

    if (this.errorManagerService.immageFormatError($event.target.files[0].type)) {
      if ($event.target.files[0].size <= 8389000) {
        var image: any = new Image();
        var file: File = $event.target.files[0];
        var myReader: FileReader = new FileReader();
        var that = this;
        myReader.onloadend = function (loadEvent: any) {
          image.src = loadEvent.target.result;
          that.cropper.setImage(image);
          if (loadEvent.target.result !== undefined) {
            that.user.image = loadEvent.target.result;
            that.imageProfile = image.src;
          }
        };
        myReader.readAsDataURL(file);
      } else {
        this.errorManagerService.commonError({ 'code': 5010 });
      }
    } else {
      this.errorManagerService.commonError({ 'code': 5011 });
    }
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    //document.body.scrollTop = 0;
    this.getUserById(this.cookieManagerService.getCookie(CookieNames.username, false));
    let subcriptionPackage = this.subscriptionInfoService.getUserSubscribedPackage();
    this.currentSubscriptionPackageId = subcriptionPackage ? subcriptionPackage.toString():"" ;//? JSON.parse(this.subscriptionInfoService.getUserSubscribedPackage().toString()): null;
    this.getUserSubscribedPackageDetails();

  }


  getUserSubscribedPackageDetails(){
    this.httpClientService.get(ApiEndpoints.getSubscriptionPackages).subscribe(response => {
      for (let index = response.length - 1; index >= 0; --index) {
        if(this.currentSubscriptionPackageId == response[index]._id){
          this.currentSubscriptionPackage = response[index];
        }
      }
    });
  }

  getUserById(id) {
    this.httpClientService.authGet(ApiEndpoints.getUserById, null).subscribe(response => {
      this.user = new NewUser(response.user);
      if (this.user.image) {
        this.imageProfile = this.user.image;
      } else {
        this.imageProfile = '/assets/img/default-avatar.svg';
      }
      this.isSoundEnambled = this.user.setting ? this.user.setting.isSoundEnambled : false;
      this.localStorageService.remove(CookieNames.userImage);
      this.localStorageService.set(CookieNames.userImage, this.imageProfile);
      this.customObserverService.setData(this.user.image);

      this.selectedUser = Object.assign({}, this.user);
      this.resetForms();
    }, error => {
      this.errorManagerService.setError(error);
    });

  }

  addClass() {
    this.showImageCropper = false;
  }

  userProfileUpdate(user, part) {
    if (this.settingsProfile.controls['firstname'].valid && this.settingsProfile.controls['lastname'].valid) {
      this.updateUser(user, part);
    }
    this.showImageCropper = true;
  }

  updateUser(user, part) {
    let that = this;
    that.apiRequstWaiter = false;
    if (this.user.image === undefined) {
      this.user.image = this.localStorageService.get(CookieNames.userImage);
    } else {
      this.user.image = this.data.image;
    }
    if (this.user.image == "/assets/img/default-avatar.svg") {
      this.user.image = undefined;
    }
    if(!this.user.setting.billingEmail[this.user.setting.billingEmailIndex]){
      this.user.setting.billingEmailIndex=0;
    }
    this.httpClientService.authPut(ApiEndpoints.updateUser, user).subscribe(response => {
    that.apiRequstWaiter = true;
      this.user = new NewUser(response.user);
      this.selectedUser = Object.assign({}, this.user);
      if (this.user.image) {
        this.localStorageService.set(CookieNames.userImage, this.user.image);
        this.customObserverService.setData(this.user.image);
        this.imageProfile = this.user.image;
      } else {
        this.user.image = this.localStorageService.get(CookieNames.userImage);
      }
      this.cookieManagerService.setCookie(CookieNames.name, this.user.getDisplayName(), false, 1);
      this.customObserverService.setName(this.user.getDisplayName());
      this.cookieManagerService.setCookie(CookieNames.userobj, JSON.stringify(this.user));

      if (response.code && response.code === 2012) {
        swal({
          title: that.translateService.instant('ACCEPT_ACCOUNT'),
          text: that.translateService.instant('VERIFY_PASSWORD_EMAIL1') + response.user.emailChangeToken.tempMail + that.translateService.instant('VERIFY_PASSWORD_EMAIL2'),
          inputClass: 'glyphicon',
          inputPlaceholder: that.translateService.instant('ENTER_PASSWORD'),
          input: 'text',
          showCancelButton: true,
          customClass: 'sms_mobile_input',
          confirmButtonClass: 'swal2-confirm-left',
          confirmButtonText: that.translateService.instant('CONFIREM'),
          cancelButtonText: that.translateService.instant('BTN_SKIP'),
          confirmButtonColor: '#5cb85c',
          showLoaderOnConfirm: true,
          allowOutsideClick: false,
          preConfirm: (code) => {
            return new Promise((resolve, reject) => {
              setTimeout(() => {
                that.httpClientService.authPost(ApiEndpoints.changeEmail, { accessToken: code }).subscribe(response => {
                  that.user=new NewUser(response.user);
                  that.selectedUser = Object.assign({}, that.user);
                  that.isSaveButtonClick=true;
                  resolve();
                }, error => {
                  if (error.json().code = 4017) {
                    reject(that.translateService.instant('CODE_ERROR'))
                    return;
                  }
                  reject(that.translateService.instant('CODE_ERROR'))
                });
              }, 2000)
            })
          },
        }).then(function (email) {
          that.resetForms();
          swal(that.swalService.getSettingEmailConfermationSuccess())
        }, function (dismiss) {
          if (dismiss === 'cancel') {
            return;
          }
        });
      } else {
        if(part == "UNSUBSCRIBE"){
          that.resetForms();
          this.showMessage('INFORMATION','UNSUBSCRIPTION_WAITING', 'info' );
          swal.showLoading();
          if(response.user.subscriptionStatusMessage){
            var sss  = response.user.subscriptionPackageId;
            this.subscriptionInfoService.checkSubscriptionStatus(0,user.mobile, response.user.subscriptionPackageId, "unsubscribe").then((result: any) => {
              swal.close();
              if(result.code === 200){
                that.subscriptionInfoService.setCurrentSubscriptionPackage(result.packageId);
                this.currentSubscriptionPackageId = result.packageId;
                this.getUserSubscribedPackageDetails();
                this.showMessage('SW_MESSAGE1', 'UNSUBSCRIBE_SUCCESS', 'success');
              }
              else{
                this.showMessage('SW_HEAD2', 'YOU_WILL_NOTIFY_UNSUBSCRIPTION', 'error');
              }

            });
          }
        }
        else if (part !== 'payment') {
          that.resetForms();
          swal({
            title: this.translateService.instant('SW_MESSAGE1'),
            html: this.translateService.instant('SW_BODY1'),
            type: 'success',
            allowOutsideClick: false
          });
        }
      }
      this.settingsChangePassword.reset();
      this.settingsChangePasswordSocal.reset();
    }, error => {
      that.apiRequstWaiter = true;
      if (error.json().code === 4022) {
        swal({
          title: this.translateService.instant('SW_HEAD2'),
          html: this.translateService.instant('SW_BODY2'),
          type: 'error'
        });
      } else if(error.json().message == "HAVEN'T_SUBSCRIBED_TO_THIS_PACKAGE"|| error.json().message == "ALREADY_SUBSCRIBED_THIS_PACKAGE" || error.json().message == "HAVE_DEFAULT_FREE_PACKAGE"){
        swal({
          title: this.translateService.instant('SW_HEAD2'),
          html: this.translateService.instant('SW_BODY4'),
          type: 'error'
        });
      }
      else{
        swal({
          title: this.translateService.instant('SW_HEAD2'),
          html: this.translateService.instant('SW_BODY4'),
          type: 'error'
        });
        this.errorManagerService.setError(error);
      }
    });
    window.scrollTo(0, 0);
  }

  resetForms() {
    let usr = Object.assign({}, this.selectedUser);
    this.user = usr;
    this.settingsProfile.controls['email'].reset({ value: this.user.email, disabled: this.user.email });
    this.settingsChangePasswordSocal.controls['newPassword'].reset({ value: '', disabled: !this.user.email });
    this.settingsChangePasswordSocal.controls['reEnterPassword'].reset({ value: '', disabled: !this.user.email });
    this.settingsChangePassword.reset();
    this.settingsChangePasswordSocal.reset();
    this.isSaveButtonClick = false;
    this.user.image = this.localStorageService.get(CookieNames.userImage);
    window.scrollTo(0, 0);
  }

  delete(index: number, type) {
    let that = this;
    swal(that.swalService.getSettingDeleteSuccess()).then(function () {
      if (type === 'mobile') {
        that.user.setting.mobile.splice(index, 1);
        that.updateUser(that.user, 'payment');
      }
      if (type === 'email') {
        that.user.setting.billingEmail.splice(index, 1);
        that.updateUser(that.user, 'payment');
      }
    }, function (dismiss) { });
  }

  toggleEdit(index, type: string, input, inputField) {
    if (type === 'email') {
      this.user.billingEmail = this.user.setting.billingEmail[index].data;
    }
    if (type === 'phone') {
      this.user.billingMobile = this.user.setting.mobile[index].data;
    }
  }

  addList(type: string) {
    if (type === 'email' && this.settingsPayment.controls['billemail'].valid && this.user.billingEmail) {
      if (this.objectMaper(this.user.setting.billingEmail, type) && !this.emailEdit) {
        this.user.setting.billingEmail.push({ 'data': this.user.billingEmail });
      } else {
        this.user.setting.billingEmail[this.editEmailId] = { 'data': this.user.billingEmail };
      }
      this.updateUser(this.user, 'payment');
    }
    if (type === 'mobile' && this.settingsPayment.controls['mobileNumber'].valid && this.user.billingMobile) {
      if (this.objectMaper(this.user.setting.mobile, type) && !this.mobileEdit) {
        this.user.setting.mobile.push({ 'data': this.user.billingMobile });
      } else {
        this.user.setting.mobile[this.editMobileId] = { 'data': this.user.billingMobile };
      }
      this.updateUser(this.user, 'payment');
    }
    this.emailEdit = false;
    this.mobileEdit = false;
  }

  objectMaper(objectArray, type) {
    let temp = [];
    objectArray.map((_array) => {
      return _array.data;
    }).forEach((data) => {
      if (type === 'email') {
        if (data == this.user.billingEmail) {
          temp.push(data);
        }
      }
      if (type === 'mobile') {
        if (data === this.user.billingMobile) {
          temp.push(data);
        }
      }
    });
    if (temp.length === 0) {
      return true;
    } else {
      return false;
    }
  }
  _keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  trimText() {
    this.user.firstname = this.settingsProfile.controls['firstname'].value.trim();
    this.user.lastname = this.settingsProfile.controls['lastname'].value.trim();
  }

  unsubscribeConfiremation(){
    let that = this;
    swal({
      title: that.translateService.instant("CONFIRMATION"),
      html: "<h4>"+ that.translateService.instant("UNSUBSCRIPTION_CONFIREMATION") +"</h4>",
      showCancelButton: true,
      showConfirmButton: true,
      cancelButtonColor: '#f39c12',
      confirmButtonColor: '#3085d6',
      confirmButtonText: that.translateService.instant("YES"),
      cancelButtonText: that.translateService.instant("NO"),
      confirmButtonClass: 'swal2-confirm-left',
    }).then(function () {
      let userSubscription = new UserSubscritpion();
      if(that.currentSubscriptionPackageId){
        userSubscription.subscriptionPackageId = that.currentSubscriptionPackageId;
        userSubscription.status = "UNSUBSCRIBE";
        that.user.userSubscription = userSubscription;
        that.updateUser(that.user, "UNSUBSCRIBE");
      }
    });
  }  

  showPackagesPopUp(){
    $('#packages-pop').modal('show');
  }

  showMessage(header, content, type){
    swal({
      title: this.translateService.instant(header),
      html: this.translateService.instant(content),
      type: type
    });
  }

}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/setting/setting.component.ts